import { ref } from "vue";
import { defineStore } from "pinia";
import isSpacedString from "@/helpers/isSpacedString";
import { Department } from "@/interfaces/department";

export const useDepartmentSearchStore = defineStore("departmentsSearch", () => {
  const query = ref("");
  const departments = ref<Department[]>([]);

  return {
    query,
    departments,

    setQuery(value: string) {
      if (!isSpacedString(value)) {
        query.value = value;
      }
    },
    setDepartments(value: Department[]) {
      departments.value = value;
    },
    resetState() {
      query.value = "";
      departments.value = [];
    },
  };
});
